import RecordOutcomeDialog from "../Challenge/RecordOutcomeDialog";

// Deed-stage determination (V10.1) — EcoChallenge.recordOutcome, replacing
// EcoBank.judgeDeedChallenge(tokenId, upheld). Kept as a named wrapper so SettlementPanel's
// import and props are unchanged; the dialog itself is shared with the verification stage in
// components/Challenge/RecordOutcomeDialog.tsx, which carries the full explanation.
//
// What changed for the caller: the verdict is no longer one GTA's relayed signature but a drawn
// panel's (or single checker's) EIP-712 signatures submitted in a direct transaction. And an
// UPHELD verdict no longer unwinds the sale — the settlement stays CHALLENGED until the covenant
// is reseated and re-verified, then releases. Nothing here queues a refund.

export interface JudgeChallengeDialogProps {
  open: boolean;
  onClose: () => void;
  // On-chain token id (the Bank's settlement key).
  tokenId: number | string;
  // Connected wallet — the dialog says whether it holds a seat on the drawn panel.
  viewerAddress?: string | null;
  // Called once the determination is mined, so the caller can re-read the settlement.
  onJudged?: (upheld: boolean) => void;
}

const JudgeChallengeDialog = ({ open, onClose, tokenId, viewerAddress, onJudged }: JudgeChallengeDialogProps) => (
  <RecordOutcomeDialog
    open={open}
    onClose={onClose}
    stage="deed"
    tokenId={tokenId}
    viewerAddress={viewerAddress}
    onJudged={(upheld) => onJudged?.(upheld)}
  />
);

export default JudgeChallengeDialog;
